<template>
  <div class="content">
       <el-row class="content-head">
            <el-col :span="24">
                <div class="grid-content bg-purple-dark">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item class="msgitem" >访客管理系统</el-breadcrumb-item>
                </el-breadcrumb>
                </div>
            </el-col>
        </el-row>
    <div class="content-top">
      <span style="font-size:16px" :class="type == 1? 'active' : ''" @click="changeType(1)">通行记录</span>
      <span style="font-size:16px" :class="type == 2? 'active' : ''" @click="changeType(2)">访客登记</span>            
         <!-- 搜索框上 -->
          <div style="display:flex;justify-content:right;align-items: center;height:56px;padding:0 1vw;  margin-left:20px;float: right;" >
            <div class="grid-search" style="width:40vw;display:flex;margin:0px 0px 0px 0px;justify-content:right;margin-right:20px;align-items:center">
              <div style="display: flex;
              justify-content:right;
              align-items: center;
              font-size: 16px;
              margin-left:15px;
              width: 35vw;
              ">
               <el-date-picker
               v-if="type == 1"
               style="width:600px;margin-right:15px"
                 size="medium"
              value-format="yyyy-MM-dd"
                @change="searchBnd"
               v-model="formsearch.time"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
              <el-input v-if="type == 1" style="margin-right:15px" @change="searchBnd" clearable v-model="formsearch.name" placeholder="请输入姓名"></el-input>
              <el-input v-if="type == 1" @change="searchBnd" clearable v-model="formsearch.idCard" placeholder="请输入身份证号"></el-input>
              
              <!-- <el-input v-if="type == 1" style="margin-right:15px;margin-left:15px" @change="searchBnd" clearable v-model="formsearch.clockTime" placeholder="请输入通行时间"></el-input> -->
               <el-input v-if="type == 2" style="margin-right:15px" @change="searchBtn" clearable v-model="formsearch.name" placeholder="请输入姓名"></el-input>
              <el-input v-if="type == 2" @change="searchBtn" clearable v-model="formsearch.idCard" placeholder="请输入身份证号"></el-input>
              </div>     
            </div>
              <div v-if="type == 1" style="margin-right:15px" class="search" @click="searchBnd">查询</div>
              <div v-if="type == 2" style="margin-right:15px" class="search" @click="searchBtn">查询</div>
              

            <div v-if="type == 2" style="margin-right:50px" class="crea"  @click="addPlan">录入访客</div>
            
          </div>  
    </div>
    <div class="content-box">
      <!-- <planpro-view v-if="type == 1" @toAdd="receive" @toEdit="editFun"></planpro-view>
      <add-patrol v-else-if="type == 2" :flag="flag" :panId="id" :edit="edit" :obj="data"></add-patrol> -->
         <div class="contentA"  v-if="type == 1">
    <!-- 主体 -->
    <el-container class="content-container">
      <!-- 右边 -->
      <el-main
        class="build-CURD"
        style="height: 100%;padding:0px !important; position: relative;width: 100%;"
      >
        <el-card class="box-card box-card_right" style="height:100%;padding:0px !important;">    
          <div class="build-table">
            <el-table
               stripe
              :data="tableData"
              height="95%"
              style="width: 100%;"
              :default-sort="{prop: 'clockTime', order: 'descending'}"
              :row-style="{height:'20px'}"
              :header-cell-style="{textAlign:'center',color:'#909399',fontFamily: 'SourceHanSansCN-Regular',fontSize:'14px',fontWeight: 'normal',background:'#F5F7F9'}"
              :cell-style="{height:'20px',color: '#666666',fontSize: '12px',fontFamily: 'SourceHanSansCN-Normal'}"
             
            >
              <template slot="empty">
                <p>{{dataText}}</p>
              </template>
              <!-- <el-table-column type="selection" width="50"></el-table-column> -->
                <el-table-column
                    label="序号"
                    type="index"
                    align="center"
                    width="200px"
                   
               ></el-table-column>
              <el-table-column label="姓名" style="align:center;" >
                <template slot-scope="scope">
                  <span>{{ scope.row.name}}</span>
                </template>
              </el-table-column>
              <el-table-column label="身份证号" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.idCard }}</span>
                </template>
              </el-table-column>
              <el-table-column label="门禁卡号" align="center">
                <template slot-scope="scope">
                  <span>{{scope.row.icCard}}</span>
                </template>
              </el-table-column>
                <el-table-column label="通行体温" align="center">
                <template slot-scope="scope">
                  <span v-if="!scope.row.temperature||scope.row.temperature==''"></span>
                  <span v-else-if="scope.row.temperature<37.4" style="color:#23D715;">{{ scope.row.temperature||0 }}℃</span>
                  <span v-else-if="scope.row.temperature>=37.4" style="color:#F56C6C;">{{ scope.row.temperature||0 }}℃</span>
                  <span v-else>{{ scope.row.temperature }}℃</span>
                </template>
              </el-table-column>
                 <el-table-column label="健康码" width="200">
                <template slot-scope="scope">
                <img :src="scope.row.codeImg" style="height: 6vh" />
                </template>
              </el-table-column>
              <!-- <el-table-column label="身份证照片" align="center">
                <template slot-scope="scope">
                  <el-image style="width:70px;height:90px;" v-if="scope.row.photoFile !=''" :src="scope.row.photoFile" :preview-src-list="[scope.row.photoFile]"></el-image>
                  <div
                    v-else
                    style="width:70px;height:90px;background: #ddd;display: flex;align-items: center;justify-content: center;"
                  >暂无图片</div>
                </template>
              </el-table-column> -->
              <el-table-column    label="通行照片" align="center"  prop="clockTime" >
                 <template slot-scope="scope">
                  <el-image style="width:70px;height:90px;" v-if="scope.row.photoFile !=''" :src="scope.row.photoFile" :preview-src-list="[scope.row.photoFile]"></el-image>
                 <div
                    v-else
                   class="duis"
                  >暂无图片</div>
                </template>
              </el-table-column>
              <el-table-column   label="通行时间" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.clockTime }}</span>
                </template>
              </el-table-column>     
              
            </el-table>
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pageNum1"
              :page-sizes="[5, 10, 20, 50]"
              :page-size="pageSize1"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            ></el-pagination> 
          </div>
        </el-card>
      </el-main>
    </el-container>
  </div>
          <div class="contentA"  v-if="type == 2">
    <!-- 主体 -->
    <el-container class="content-container">
      <!-- 右边 -->
      <el-main
        class="build-CURD"
        style="height: 100%;padding:0px !important; position: relative;width: 100%;"
      >
        <el-card class="box-card box-card_right" style="height:100%;padding:0px !important;">
     
          <div class="build-table">
            <el-table
               stripe
              :data="listData"
              height="95%"
              style="width: 100%;"
              :default-sort="{prop: 'clockTime', order: 'descending'}"
              :row-style="{height:'20px'}"
              :header-cell-style="{textAlign:'center',color:'#909399',fontFamily: 'SourceHanSansCN-Regular',fontSize:'14px',fontWeight: 'normal',background:'#F5F7F9'}"
              :cell-style="{height:'20px',color: '#666666',fontSize: '12px',fontFamily: 'SourceHanSansCN-Normal'}"
             
            >
              <template slot="empty">
                <p>{{dataText}}</p>
              </template>
              <!-- <el-table-column type="selection" width="50"></el-table-column> -->
                <el-table-column
                    label="序号"
                    type="index"
                    align="center"
                    width="100"
               ></el-table-column>
              <el-table-column label="姓名" align="center" width="100px">
                <template slot-scope="scope" >
                  <div style="float:left">{{ scope.row.name}}</div>
                  <div style="width:40px;height:18px;font-size:12px;border:1px #ccc solid;float:left;text-align:center; line-height:18px;margin-top:10px; border-radius: 4px;" :style="{'color':[scope.row.status==0?'#ccc':(scope.row.status==1?'blue':'#000')]}">{{ scope.row.status==0?'已失效':(scope.row.status==1?'生效中':'未生效')}}</div>
                </template>
              </el-table-column>
              <el-table-column label="身份证号" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.idCard }}</span>
                </template>
              </el-table-column>
              <el-table-column label="门禁卡号" align="center">
                <template slot-scope="scope">
                  <span>{{scope.row.icCard}}</span>
                </template>
              </el-table-column>
              <el-table-column label="身份证照片" align="center">
                 <template slot-scope="scope">
                  <el-image style="width:70px;height:90px;" v-if="scope.row.idCardPhoto !=''" :src="scope.row.idCardPhoto" :preview-src-list="[scope.row.idCardPhoto]"></el-image>
                  <div
                    v-else
                    style="width:70px;height:90px;background: #ddd;display: flex;align-items: center;justify-content: center;"
                  >暂无图片</div>
                </template>
              </el-table-column>                
                <el-table-column   label="采集照片" align="center">
                 <template slot-scope="scope">
                  <el-image style="width:70px;height:90px;" v-if="scope.row.facePhoto!=''" :src="scope.row.facePhoto" :preview-src-list="[scope.row.facePhoto]"></el-image>
                  <div
                    v-else
                    style="width:70px;height:90px;background: #ddd;display: flex;align-items: center;justify-content: center;"
                  >暂无图片</div>
                </template>
              </el-table-column>   
               <el-table-column   label="登记时间" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.startDate }}</span>
                </template>
              </el-table-column>                   
                <el-table-column label="授权有效期" align="center">
                <template slot-scope="scope">
                  <span>开始时间：{{ scope.row.startDate }}</span><br>
                    <span>截止时间：{{ scope.row.endDate }}</span>
                </template>
              </el-table-column> 
     
                   <el-table-column label="操作" align="center" width="140px">
                <template slot-scope="scope">
                    <div class="chakan" style="margin: 0 4px 0 4px"  @click="handleAdd(scope.row)">编辑</div>               
                    <div class="shanchu " style="margin: 0 4px 0 4px"  @click="handleEdit(scope.row)">删除</div>               
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pageNum"
              :page-sizes="[5, 10, 20, 50]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalItems"
            ></el-pagination> 
          </div>
        </el-card>
      </el-main>
    </el-container>
  </div>
    </div>
  
  </div>

</template>

<script>
import util from '../../untils/util'
import myHttp from '../../untils/port'
import base from '../../untils/base'

  export default {
   
    data() {
      return {
        type: 2,
        flag: 2,
        id: '',
        data: '',
        edit: false,
         listData: [],
         tableData:[],
         formsearch:{
          name:'',
          idCard:'',
          time:''
         },
      search: {
     
        //查询
        // name: '',
        // projectId: '',
        // date:util.myTime.getCurTime(),
        // temperatureType:'2',
        // teamsId: '',
        // entId: '',
        // personName: '',
      },
      groupId: '',
      dataText: '暂无数据',
        healthLevel: '',
      pageNum: 1,
      pageSize: 10,
      totalItems: 0,
       pageNum1: 1,
      pageSize1: 10,
      total: 0,
      modifyVisible: false,
      workerInfo: {
        id: '',
  
        projectId: '',
        napeId:'',
        around:'',
        entId:'',
        planDate:'',
        userId:''
      },
     
    
      //责任人
      personList:[],
      planDate:'',
      userName:'',
      napeId:'',
    projectId:''
      }
    },
    created() {
    this.groupId = util.session.get('groupId')
      
    },
    activated(){
    this.getVisVisitorPage()

    },
    mounted(){
      console.log(util.session.get('typeSS'))
      if(util.session.get('typeSS')!=''&&util.session.get('typeSS')!=null){
        this.type = util.session.get('typeSS')
        util.session.remove('typeSS')
      }
       this.search.projectId = this.groupId
    if (this.search.projectId == '') {
      this.$store.commit('setGroupId')
      this.search.projectId = this.$store.state.groupId
    }
    this.getVisVisitorPage()
    this.getVisVisitorRecordPage()
   
    },
    methods: {
      changeType(type){
        this.type = type    
        this.pageNum = 1;
        if (type==1) {
    this.getVisVisitorRecordPage()
          
        }
         if (type==2) {
    this.getVisVisitorPage()
          
        }
     
       
      },
      receive(id){
        this.type = 2
        this.flag = 1
        this.id = id
        this.edit = false
      },
      editFun(data){
        this.type = 2
        this.flag = 1
        this.data = data
        this.id = data.id
        this.edit = true
      },
        handleSizeChange(val) {
        this.pageSize = val
        this.handleCurrentChange(this.pageNum)
    },
    handleCurrentChange(val) {
        this.pageNum = val
        this.currentChangePage()
    },
    // 监控当前页码
    currentChangePage(list) {
        this.getVisVisitorPage()
    },
     handleSizeChange(val) {
        this.pageSize1 = val
        this.handleCurrentChange(this.pageNum1)
    },
    handleCurrentChange(val) {
        this.pageNum1 = val
        this.currentChangePage()
    },
    // 监控当前页码
    currentChangePage(list) {
        this.getVisVisitorRecordPage()
    },
   
      // 搜索数据
    searchBtn() {
      this.pageNum = 1;
      this.getVisVisitorPage();
     
    },
     searchBnd() {
      this.pageNum = 1;
      this.getVisVisitorRecordPage();
     
    },
      // changeType(status) {
      //   console.log(status)
      //   if(status == 1){
      //     this.search.status = ''
      //   }else{
      //     this.search.status = status
      //   }
        
      //   this.searchBtn()
      //   this.searchBnd()
      // },
  //列表数据2
   getVisVisitorPage() {
      let that = this;  
        this.formsearch.projectId=this.groupId,
        this.formsearch.pageNum=this.pageNum,
        this.formsearch.pageSize=this.pageSize,        
      myHttp.getVisVisitorPage( this.formsearch).then(
        function (resp) {
            if (resp.data.code == 200) {
               var list = resp.data.data.visVisitorsPage.list || []
            for (var i = 0; i < list.length; i++) {
              list[i].index = (that.pageNum - 1) * that.pageSize + (i + 1)
              list[i].idCardPhoto = list[i].idCardPhoto && list[i].idCardPhoto != '' ? base.httpCtx + list[i].idCardPhoto +'?' + new Date().getMilliseconds(): ''
              list[i].facePhoto = list[i].facePhoto && list[i].facePhoto != '' ? base.httpCtx + list[i].facePhoto +'?' + new Date().getMilliseconds() : ''
              // list[i].typeName = that.filterSatus(list[i].status)
             
            }
               that.listData = list
              that.totalItems = resp.data.data.visVisitorsPage.total;
               if (that.listData.length == 0) {
              that.dataText = '暂无数据'
            }
            } else {
              that.$message.error(data.msg);
          

            }
        
        },
        function () {}
      );
    },
     //列表数据1
   getVisVisitorRecordPage() {
      let that = this;    
        this.formsearch.projectId=this.groupId,
        this.formsearch.pageNum=this.pageNum1,
        this.formsearch.pageSize=this.pageSize1,        
      myHttp.getVisVisitorRecordPage( this.formsearch).then(
        function (resp) {
          if (resp.status == 200) {
            let data = resp.data;
            if (data.code == 200) {
               var list = resp.data.data.visVisitorRecordsPage.list || []
            for (var i = 0; i < list.length; i++) {
              list[i].index = (that.pageNum - 1) * that.pageSize + (i + 1)
              // list[i].idCardPhoto = list[i].idCardPhoto && list[i].idCardPhoto != '' ? base.httpCtx + list[i].idCardPhoto: ''
              list[i].photoFile = list[i].photoFile && list[i].photoFile != '' ? base.httpCtx + list[i].photoFile : ''

                if (list[i].healthLevel == '1') {
                list[i].codeImg = require('../../assets/image/new/green.png')
              } else if (list[i].healthLevel == '2') {
                list[i].codeImg = require('../../assets/image/new/yellow.png')
              } else if (list[i].healthLevel == '3') {
                list[i].codeImg = require('../../assets/image/new/red.png')
              } else {
                list[i].codeImg = require('../../assets/image/new/no.png')
              }
            }
               that.tableData = list           
              that.total = resp.data.data.visVisitorRecordsPage.total;
             
            
            } else {
              that.$message.error(data.msg);
            }
          }
        },
        function () {}
      );
    },
    // 编辑
    handleAdd(row){
      console.log(row);
     this.$router.push({name:'visitorEdit',params:{id:row.id}});
    },
    // 删除
    handleEdit(row){
      let that = this;
  console.log(row);
 this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let del = {
          id: row.id,
        };
        myHttp.deleteVisVisitorLogic(del).then((res) => {
          // console.log(res);
          if (res.data.code == 200) {
            this.$message.success("删除成功");
      
            that.getVisVisitorPage();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
   
    //添加计划
    addPlan(){
     this.$router.push({path:'/visitorMessage'})
    },
    
    },
  }
</script>
<style>
  @import '../../assets/css/common.css';
</style>
<style scoped>
/* .content{
  padding: 1vh 1vw;
} */
.content-top{
  height: 56px;
  border-radius: 6px;
  background-color: #fff;
  text-align: left;
  margin-bottom: 6px;
}
.content-top > span {
  margin-left: 18px;
  padding-bottom: 18px;
  line-height: 56px;
  cursor: pointer;
}
.content-box{
  height: calc(100% - 64px);
  overflow: none;
}
.active{
  border-bottom: 2px solid #4D6EB1;
}
  .msgitem{
   
       margin-left: 10px;
 
    }
    .grid-content {
    height: 2.5vh;
    font-size: 1.6vh;
  }
  .aside {
    box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
    border-radius: 10px !important;
    border: 0px !important;
    background-color: rgb(255, 255, 255);
  }
  .contentA >>> .el-card__body {
    padding: 0 !important;
    height: 100% !important;
  }
  .contentA{
    width: 100%;
    height: 84vh;
    margin-top: 0!important;
  }
  ::v-deep.el-table--border, .el-table--group {
    border: 1px solid #EBEEF5;
}
  .build-table {
    height: calc(100% - 100px);
    padding: 1vh;
    position: relative;
    margin-top: 5px;
  }
  .cur{
    background: #ECF5FF !important;
    color:#409EFF !important  ;
  }
  div >>> .el-dialog__header {
    padding: 20px 20px 10px;
    text-align: center !important;
  }
  .send >>> .el-dialog__header {
    text-align: center !important;
  }
  div >>> .el-dialog__footer {
    padding: 10px 20px 20px;
    text-align: center;
    box-sizing: border-box;
  }
  div >>>.el-input-group--append .el-input__inner{
    width: 200px;
    height: 33px;
  }
  .dialog_send{
    margin:10px 0px 10px 25px;
  }
  .dialog_end{
    padding:30px 0px 10px 35px;
    display: flex;
    justify-content: flex-end;
  }
  .else{
    justify-content: space-between;
    border-top: 1px dotted #ECF5FF;
  }
  .tips{
        display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 14px;
      cursor: pointer;
      
  }
  .search{
    width: 80px;
    height: 32px;
    border-radius: 6px;
    background: #FDFEFE;
    box-sizing: border-box;
    border: 1px solid rgba(153, 153, 153, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: SourceHanSansCN-Regular;
    font-size: 14px;
    font-weight: normal;
    letter-spacing: 0em;
    color: #666666;
  }
  .search:hover{
    opacity: 0.7;
    cursor: pointer;
  }
  .crea{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 80px;
height: 32px;
border-radius: 6px;
background: #FDFEFE;
box-sizing: border-box;
border: 1px solid rgba(153, 153, 153, 0.8);
font-family: SourceHanSansCN-Regular;
font-size: 14px;
font-weight: normal;
letter-spacing: 0em;
color: #666666;
  }
  .crea:hover{
    opacity: 0.7;
    cursor: pointer;
  }
  .chakan{
     float: left;
    display: flex;  
    align-items: center;
    width: 50px;
padding-left: 10px;
height: 24px;
border-radius: 4px;
background: rgba(227, 233, 246, 0.05);
box-sizing: border-box;
border: 1px solid rgba(142, 163, 206, 0.8);
font-family: SourceHanSansCN-Regular;
font-size: 14px;
font-weight: normal;
letter-spacing: 0em;
color: #8EA3CE;
  }
  .shanchu{
    float: left;
    display: flex;  
    /* align-items: center; */
    width: 50px;
height: 24px;
padding-left: 10px;
border-radius: 4px;
text-align: center;
line-height: 24px;
background: rgba(227, 233, 246, 0.05);
box-sizing: border-box;
border: 1px solid rgba(142, 163, 206, 0.8);
font-family: SourceHanSansCN-Regular;
font-size: 14px;
font-weight: normal;
letter-spacing: 0em;
color: #8EA3CE;
  }
    /* .chakan1{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50px;
   
height: 24px;
border-radius: 4px;
background: rgba(227, 233, 246, 0.05);
box-sizing: border-box;
border: 1px solid #F7A7A7;;
font-family: SourceHanSansCN-Regular;
font-size: 14px;
font-weight: normal;
letter-spacing: 0em;
color: #F7A7A7;;
  } */
  .chakan:hover{
    opacity: 0.7;
    cursor: pointer;
  }
    .shanchu:hover{
    opacity: 0.7;
    cursor: pointer;
  }
  .chakan1:hover{
    opacity: 0.7;
    cursor: pointer;
  }
  ::v-deep .el-table th.el-table__cell>.cell{
    font-size: 14px !important;
  }
  ::v-deep .cell>span{
    font-size: 14px !important;
    text-align: center !important;
  }
  ::v-deep .cell{
    font-size: 14px !important;
    text-align: center  !important;
  }
  ::v-deep .el-input__inner{
    height: 33px;
  }
  ::v-deep .el-pagination{
    padding: 0;
    padding-top:1.2vh ;
   
  }
  .el-table >>> th.el-table__cell>.cell{
    padding-left: 5px;
  }
   ::v-deep.el-table .cell{
     padding-left: 5px;
  }
  ::v-deep .ediut{
    text-align: center  !important;
  }
   ::v-deep .duis{
width: 70px;
height: 90px;
font-size: 14px;
margin-left: 65px;
background: #eee;
text-align: center;
line-height: 90px;

  }
</style>